import { Component } from '@angular/core';
import get from 'lodash/fp/get';
import groupBy from 'lodash/fp/groupBy';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ChannelGroup } from '../../../models';
import { ChatService } from '../chat.service';

@Component({
  selector: 'bidi-group-list',
  templateUrl: './group-list.component.html',
  styleUrls: ['./group-list.component.scss']
})
export class GroupListComponent {
  groups$: Observable<ChannelGroup[]> = this.chatService.channels$.pipe(
    map(channels => Object.values(groupBy('groupId', channels)))
  );

  selectedGroupId$: Observable<string> = this.chatService.selectedGroup$.pipe(
    map(get([0, 'groupId']))
  );

  constructor (public chatService: ChatService) {
  }
}
